import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startSaveNote, startUploading } from '../../actions/notes';
//react-journal
export const NotesAppbar = () => {
    const dispatch = useDispatch();
    const { active: note } = useSelector(state => state.notes);

    const handleSave = () => {
        dispatch(startSaveNote(note))
    }

    const handlePictureUpload = () => {
     document.querySelector('#fileSelector').click();


        console.log('picture')
    }
    
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file){
            dispatch(startUploading(file))
        }
    }

    return (
        <div className="notes__appbar">
            <span>15 Julio 2021</span>
            <input
                id="fileSelector"
                name="file"
                type="file"
                style={{ display: 'none' }}
                onChange={handleFileChange} />

            <div>
                <button className="btn" onClick={handlePictureUpload}>
                    Picture
                </button>

                <button className="btn" onClick={handleSave}>
                    Save
                </button>
            </div>
        </div>
    )
}
